var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "fullscreen-sl",
  "use": "fullscreen-sl-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"fullscreen-sl\">\n    <path d=\"M0 0h48v48h-48z\" fill=\"none\" />\n    <path d=\"M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4h-10v10zm24 14h-6v4h10v-10h-4v6zm-6-24v4h6v6h4v-10h-10z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id